module.exports = __webpack_public_path__ + "img/ring_r_c_0_1@3x.3a3f394c.png";